/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { ContentChildren, Directive, Optional, QueryList } from "@angular/core";

import { UiThMeasureDirective } from "../cell/th-measure.directive";
import { NzTrDirective } from "ng-zorro-antd/table";
import { UiCellFixedDirective } from "@webapp/ui/table/directives/cell/cell-fixed.directive";
import { UiTableStyleService } from "@webapp/ui/table/services/table-style.service";

@Directive({
  selector: "tr:not([mat-row]):not([mat-header-row]):not([ui-table-measure-row]):not([uiExpand]):not([ui-table-fixed-row])",
  host: {
    "[class.ant-table-row]": "isInsideTable",
  },
})
export class UiTrDirective extends NzTrDirective {
  @ContentChildren(UiThMeasureDirective) public listOfNzThDirective!: QueryList<UiThMeasureDirective>;
  @ContentChildren(UiCellFixedDirective) public listOfCellFixedDirective!: QueryList<UiCellFixedDirective>;

  constructor(@Optional() uiTableStyleService: UiTableStyleService) {
    super(uiTableStyleService);
  }
}
